import { render, staticRenderFns } from "./noticeCard.vue?vue&type=template&id=44115522&scoped=true"
import script from "./noticeCard.vue?vue&type=script&lang=js"
export * from "./noticeCard.vue?vue&type=script&lang=js"
import style0 from "./noticeCard.vue?vue&type=style&index=0&id=44115522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44115522",
  null
  
)

export default component.exports